import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, IconButton, Typography } from '@mui/material';
import ServiceAvengerIcon from '../../assets/SeviceAvengerIcon.svg';
import './ServicerNavBar.scss';
import { getMenuItems } from './ServicerNavBarMenuItems';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { selectFileClaimWithoutJob, selectPostDispatchCreate, selectSelfServicingDealer } from './ReduxSelector';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { POST_DISPACTH_VALIDATE } from 'constant';
const btnStyle = {
  '&.MuiButtonBase-root': { padding: '8px 2px 8px 5px' },
  width: '15vw',
  wordBreak: 'break-word',
  '& .MuiTypography-root': { fontSize: '13px' },
  '&.MuiButton-root': {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  '@media (max-width:800px)': {
    width: '16px',
    fontSize: '14px',
    padding: '4px 12px',
  },
  '@media (max-width:1023px)': {
    fontSize: '9.7px',
    padding: '0 2px',
  },
  '@media (min-width:1024px) and (max-width:1282px)': {
    fontSize: '14px',
    padding: '5px 5px',
  },
};
const gridStyle = {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
};

const ServicerNavBar = ({ setHamburgerMenu, hamburgerMenu }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [clickedButton, setClickedButton] = useState(location.state?.activeIndex);
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const fileClaimWithoutJob = useSelector(selectFileClaimWithoutJob);
  const isPsp = useSelector(selectPostDispatchCreate);
  const selfServicingDealer = useSelector(selectSelfServicingDealer);
  const serviceProvider=window.localStorage.getItem("serviceProvider");
  const isSamsungServicer=serviceProvider===POST_DISPACTH_VALIDATE.provider.samsung?true:false;
  const provider={
    isSamsung:isSamsungServicer
  }

  const menuItems = getMenuItems(fileClaimWithoutJob, isPsp, selfServicingDealer,provider);

  useEffect(() => {
    const urlRoute = location?.pathname?.split('/')[1];
    let activeKey = null;

    const activeItem = menuItems.find(
      (item) => item.path === location.pathname || item.children?.some((child) => child.path === location.pathname),
    );

    if (activeItem) {
      activeKey = activeItem.key;
      if (activeItem.children?.length > 0) {
        const activeChild = activeItem.children.find((child) => child.path === location.pathname);
        if (activeChild) {
          setExpandedAccordion(activeItem.key);
          activeKey = activeChild.key;
        } else if (activeItem.path === location.pathname) {
          setExpandedAccordion(null);
        }
      }
    }

    if (urlRoute === 'OrderDetails') {
      activeKey = '2.1';
      setExpandedAccordion('2');
    }
    if (urlRoute === 'postDispatchFileDetail') {
      activeKey = '2.3';
      setExpandedAccordion('2');
    }
    if (isAccordionOpen) {
      setExpandedAccordion(null);
    }
    setClickedButton(activeKey);
  }, [location, menuItems]);

  const handleClose = () => {
    setHamburgerMenu(false);
  };

  const handleOnClick = (item) => {
    const { key, path, isUrl } = item || {};
    const keyCloakToken = localStorage.getItem('keyCloakLoginToken');

    if (isUrl) {
      window.open(`${process.env.REACT_APP_CLAIMS_URL}/dashboard?access_token=${keyCloakToken}`);
    }

    setClickedButton(key);
    if (key === '1' || key === '3') {
      setExpandedAccordion(null);
    }

    if (path) {
      navigate(path);
    }

    handleClose();
  };

  const shouldShowItem = (item) => {
    if (item.key === '4' && fileClaimWithoutJob && isPsp) return true;
    if (item.key === '5' && fileClaimWithoutJob) return true;
    return item.show;
  };

  const handleBtnVariant = (item) => {
    return clickedButton === item?.key ? 'contained' : '';
  };

  const handleIconButtonClick = (e, item) => {
    if (item?.title === 'Jobs') {
      setIsAccordionOpen((pre) => !pre);
    } else {
      setIsAccordionOpen(false);
    }
    e.stopPropagation();
    setExpandedAccordion((prev) => (prev === item.key ? null : item.key));
  };

  return (
    <>
      <Grid xs={12} spacing={0} className="main-servicerNavBar">
        <Grid
          xs={2}
          container
          spacing={0}
          className="main-contianer-servicerNavBar"
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '80%',
          }}
        >
          <Grid className="close_icon">
            <Grid style={{ alignSelf: 'flex-end', alignContent: 'flex-end' }}>
              <CloseIcon
                style={{
                  height: '4vw',
                  width: '4vw',
                }}
                onClick={() => handleClose()}
              />
            </Grid>
          </Grid>
          <Grid xs={12} className="main-container-avatar" style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="image-container">
              <img src={ServiceAvengerIcon} alt="icon" className="serviceAvenger-icon-image" />
            </div>
          </Grid>

          {menuItems.map((item) => {
            if (!shouldShowItem(item)) return null;

            const hasChildren = item?.children && item?.children.length > 0;

            return (
              <Grid item xs={12} key={item.key}>
                {hasChildren ? (
                  <Accordion
                    expanded={expandedAccordion === item.key}
                    onChange={(e) => {
                      handleIconButtonClick(e, item);
                    }}
                    sx={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      '&:before': { display: 'none' },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        backgroundColor: 'transparent',
                        '& .MuiAccordionSummary-content': {
                          margin: 0,
                        },
                      }}
                    >
                      <Grid container alignItems="center">
                        <img src={clickedButton === item.key ? item.Icon[1] : item.Icon[0]} alt="icon" />
                        <Typography sx={{ ml: 1 }}>{item.title}</Typography>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{
                        backgroundColor: 'transparent',
                        padding: 0,
                      }}
                    >
                      {item?.children?.map((child) => {
                        if (!shouldShowItem(child)) return null;
                        return (
                          <Button
                            variant={handleBtnVariant(child)}
                            key={child.key}
                            sx={{
                              textTransform: 'none',
                              margin: '0px 0px 10px 10px',
                              paddingRight: 0,
                              paddingLeft: 2,
                              width: '95%',
                            }}
                            onClick={() => handleOnClick(child)}
                          >
                            <Grid container>
                              <img src={clickedButton === child.key ? child.Icon[1] : child.Icon[0]} alt="icon" />
                              <Typography sx={{ ml: 1 }}>{child.title}</Typography>
                            </Grid>
                          </Button>
                        );
                      })}
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  <Button
                    fullWidth
                    variant={handleBtnVariant(item)}
                    sx={{ textTransform: 'none' }}
                    onClick={() => handleOnClick(item)}
                  >
                    <Grid container alignItems="center">
                      <img src={clickedButton === item.key ? item.Icon[1] : item.Icon[0]} alt="icon" />
                      <Typography sx={{ ml: 1 }}>{item.title}</Typography>
                    </Grid>
                  </Button>
                )}
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </>
  );
};
export default ServicerNavBar;
